import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {getAccount as getAccountApi, submitReport as submitReportApi, submitTicket as submitTicketApi} from '@/services/apiUsers.js'
import {Notification, toast} from '@/components/ui'
import {useAppSelector} from "@/store";

export default function useUser() {
    const queryClient = useQueryClient()
    const {signedIn, token} = useAppSelector(state => state.auth.session)

    const {data, isLoading: isLoading, error} = useQuery({
        retry: false,
        enabled: signedIn && token?.length > 0,
        staleTime: 60000,
        queryKey: ['user'],
        queryFn: () => getAccountApi()
    })

    let accountData = data?.data;
    const {user, role} = accountData || {}


    const {mutate: submitReport, isLoading: isSubmittingReport} = useMutation(
        {
            mutationFn: ({message, details = null}) =>
                submitReportApi({message, details}),
            onSuccess: (response) => {
                if (response.success)
                    response.message &&
                    toast.push(
                        <Notification
                            type="success"
                            title={response.message}
                        />
                    )
                else
                    toast.push(
                        <Notification type="danger" title={response.message}/>
                    )
            },
            onError: (err) =>
                toast.push(<Notification type="danger" title={err.message}/>)
        }
    )

    const {mutate: submitTicket, isLoading: isSubmittingTicket} = useMutation(
        {
            mutationFn: ({title, message}) =>
                submitTicketApi({title, message}),
            onSuccess: (response) => {
                if (response.success)
                    response.message &&
                    toast.push(
                        <Notification
                            type="success"
                            title={response.message}
                        />
                    )
                else
                    toast.push(
                        <Notification type="danger" title={response.message}/>
                    )

                queryClient.invalidateQueries({queryKey: ['tickets']})
            },
            onError: (err) =>
                toast.push(<Notification type="danger" title={err.message}/>)
        }
    )

    return {
        isLoading,
        accountData,
        user,
        error,
        role,
        submitReport,
        isSubmittingReport,
        submitTicket,
        isSubmittingTicket
    }
}
